import { Descriptions, Divider, Typography } from 'antd';
import React from 'react';
import { Entity, StaffApplicantProfileProfessionViewContainerApplicantUserProfessionalFieldsFragment } from '../../../../generated';
import { Country } from '../../../../types/country';
import { HealthProfessionViewContainer } from '../../../shared/health-profession-view/health-profession-view-container';
import { FormatDate } from '../../../../constants';
import { ProfileHeaderContainer } from './profile-header.container';

const { Title } = Typography;

const TITLE = 'Professional Details';

interface ApplicantProfileProfessionViewProps {
  professionalInformation: StaffApplicantProfileProfessionViewContainerApplicantUserProfessionalFieldsFragment;
  countryData: Country[];
  entities: Entity[];
  onEdit: () => void;
}

export const ApplicantProfileProfessionView: React.FC<ApplicantProfileProfessionViewProps> = ({ professionalInformation, countryData, onEdit }) => {
  const healthProfession = professionalInformation?.healthProfession;
  const citizenshipAtTimeEnteredMedicalInstitution = professionalInformation?.citizenshipAtTimeEnteredMedicalInstitution;
  const primaryEducationalInformation = professionalInformation?.primaryEducationalInformation;

  const getCountryName = (countryCode: string, countryData: Country[]) => {
    const country = countryData.find((item) => item.countryCode === countryCode);
    return country ? country.countryName : null;
  };

  const citizenshipCountry = countryData.find((country) => country.countryCode === citizenshipAtTimeEnteredMedicalInstitution)?.countryName;
  return (
    <div>
      <ProfileHeaderContainer title={TITLE} onEdit={onEdit} />
      <Descriptions title={undefined} layout="vertical" size="small" column={1} className="w-[400px]">
        <Descriptions.Item label="Profession">
          <HealthProfessionViewContainer displayValueOnly={true} healthProfessionCode={healthProfession ?? ''} />
        </Descriptions.Item>

        <Descriptions.Item label="Citizenship at the time entering educational institution">{citizenshipCountry}</Descriptions.Item>
      </Descriptions>
      <Title level={5}>Institution that issued your Primary Professional Credential</Title>
      <div className="pl-4">
        {primaryEducationalInformation && primaryEducationalInformation.length > 0 ? (
          primaryEducationalInformation.map((edu, index) => (
            <React.Fragment key={edu?.id}>
              <Descriptions title={undefined} layout="vertical" column={2} bordered={false} size="small" className="w-[400px] pl-5">
                <Descriptions.Item label="Degree Title">{edu?.degreeTitle}</Descriptions.Item>
                <Descriptions.Item label="Attendance Start Date">{FormatDate(edu?.attendanceStartedAt) || 'N/A'}</Descriptions.Item>
                <Descriptions.Item label="Attendance End Date">{FormatDate(edu?.attendanceEndedAt) || 'N/A'}</Descriptions.Item>
                <Descriptions.Item label="Date Certificate Issued">{FormatDate(edu?.degreeIssuedAt) || 'N/A'}</Descriptions.Item>
                <Descriptions.Item label="Graduation Year">{edu?.graduationYear}</Descriptions.Item>
                <Descriptions.Item label="Institution Name">
                  {edu?.issuingInstitution?.id ? edu?.issuingInstitution?.entityName :  'Other - ' + edu?.otherIssuingInstitution?.name }
                </Descriptions.Item>
                {edu?.otherIssuingInstitution?.addressLine1 &&
                edu.otherIssuingInstitution?.city &&
                edu.otherIssuingInstitution?.stateOrProvince &&
                edu.otherIssuingInstitution?.zipOrPostalCode &&
                edu.otherIssuingInstitution?.country ? (
                  <Descriptions.Item label="Address">
                    {edu.otherIssuingInstitution.addressLine1} <br />
                    {edu.otherIssuingInstitution.city}, {edu.otherIssuingInstitution.stateOrProvince}, {edu.otherIssuingInstitution.zipOrPostalCode}, <br />
                    {getCountryName(edu.otherIssuingInstitution.country ?? '', countryData)}
                  </Descriptions.Item>
                ) : edu?.issuingInstitution?.issuingInstitution?.address ? (
                  <Descriptions.Item label="Address">
                    {edu.issuingInstitution.issuingInstitution?.address?.addressLine1} <br />
                    {edu.issuingInstitution.issuingInstitution?.address.city}, {edu.issuingInstitution.issuingInstitution?.address?.stateOrProvince}, {edu.issuingInstitution?.issuingInstitution?.address.zipOrPostalCode}, <br />
                    {getCountryName(edu.issuingInstitution?.issuingInstitution?.address.country ?? '', countryData)}
                  </Descriptions.Item>
                  ) : (
                  <Descriptions.Item label="Address">N/A</Descriptions.Item>
                  )}
              </Descriptions>
              {index < primaryEducationalInformation.length - 1 && <Divider className="pl-10" />}
            </React.Fragment>
          ))
        ) : (
          <Descriptions.Item>No primary education information available</Descriptions.Item>
        )}
      </div>
    </div>
  );
};
